import { render, staticRenderFns } from "./HolicEvent.vue?vue&type=template&id=cec4f71c&scoped=true"
import script from "./HolicEvent.vue?vue&type=script&lang=js"
export * from "./HolicEvent.vue?vue&type=script&lang=js"
import style0 from "./HolicEvent.vue?vue&type=style&index=0&id=cec4f71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec4f71c",
  null
  
)

export default component.exports